module.exports = __webpack_public_path__ + "881888c9e37f9c3c415c446a65116d04.svg";